import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { parseAxiosError } from "../../../../utils/response";
import ProfitFilter from "./ProfitFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ProfitList from "./ProfitList";
import { firstDayOfMonth, lastDayOfMonth } from "../../../../utils/timestampToDate";
import MaterialPagination from "../../../styles/materialPagination";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const ProfitContainer = ({ match }) => {
  const [profits, setProfits] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "profits", false, true),
    "currency": checkFilterItem(history, "currency", null),
    "paymentSystem": checkFilterItem(history, "paymentSystem", null),
    "service": checkFilterItem(history, "service", null),
    "dateFrom": checkFilterItem(history, "dateFrom", firstDayOfMonth()),
    "dateTo": checkFilterItem(history, "dateTo", lastDayOfMonth())
  });

  const fetchProfit = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/get-profit" + filterUrl + "&byClient=1&userId=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setProfits(response.data["profits"]);
        setTotalPageCount(response.data["totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchProfit();
  }, [filterData]);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <ProfitFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <ProfitList profits={profits} />
      {totalPageCount > 0 &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </>
  );
};

export default ProfitContainer;